/**
* @ngdoc component
* @name common.address.component:itxAddressPhone
* @description
* Phone and phone prefix component.
* @param {object} model Address model
* @param {object} form form
*/
(function() {
    'use strict';

    var itxAddressPhone = {
        bindings: {
            model:'=',
            form:'=',
            countryList:'<',
            countries:'<',
            address:'<',
            class:'<',
            isWorldWide: '<',
            hideHelper:'<',
            phoneCountry:'<',
            countryEditable: '<'
        },
        controller:   itxAddressPhoneCtrl,
        templateUrl: 'address-phone.component.html'
    };

    itxAddressPhoneCtrl.$inject = [
    ];

    function itxAddressPhoneCtrl (
    ) {
        var _this = this;

        _this.prefixRegex = /\+\d{1,3}/;

        _this.$onInit = function () {
            if (typeof _this.countryEditable === 'undefined') {
                _this.countryEditable = true;
            }

            _this.phonePrefixEditable();

            _this.phoneCountry = {
                countryCode: '',
                phonePrefix: '',
                countryName: ''
            };
            // _this.alternativePhoneCountry = {
            //     countryCode: '',
            //     phonePrefix: ' ',
            //     countryName: ''
            // };

            if(!_this.isWorldWide){

                if(_this.address && _this.address.phones && _this.address.phones[0] && _this.address.phones[0].countryCode){
                    var country = _.find(_this.countryList, function(country) {
                        return country.phonePrefix === _this.address.phones[0].countryCode;
                    });
                    _this.onSelectPrefixCountry(country, 0);
                }
                else{
                    _this.setDefaultCountry(_this.countryList);
                }

            }
            else{
                if(_this.address && _this.address.phones && _this.address.phones[0] && _this.address.phones[0].countryCode){

                }
                else{
                    _this.model.phones[0].countryCode = inditex.iStoreJSON.details.phoneCountryCode;
                }
               
            }
             
        };

        _this.phonePrefixEditable = function(){
            switch(inditex.iCountryCode) {
                case 'AE':
                case 'BH':
                case 'LB':
                case 'EG':
                case 'JO':
                case 'KW':
                case 'QA':
                    _this.prefixEditable = false;
                    _this.phoneCountryReadOnly = true;
                    break;
                default:
                    _this.prefixEditable = true;
                    _this.phoneCountryReadOnly = false;
            }
        }

        _this.checkNumber = function(){
            if(_this.phoneCountry.countryCode=='FR' &&  _.startsWith( _this.model.phones[0].subscriberNumber, '0')){
                _this.model.phones[0].subscriberNumber = _this.model.phones[0].subscriberNumber.substr(1, _this.model.phones[0].subscriberNumber.length);
            }
        };

        // new function default prefix
        _this.setDefaultCountry = function(countries) {
            _this.default = _.find(countries, function(country) {
                return country.countryCode === inditex.iStoreJSON.countryCode;
            });
            _this.onSelectPrefixCountry( _this.default);           
        };

        _this.onSelectPrefixCountry = function(item, commonPropertiesIndex) {
            
            if(_this.model.phones && item){ 
                _this.model.phones[0].countryCode = item.phonePrefix;
                _this.phoneCountry = _.clone(item);
            } 
            // } else {
            //     _this.alternativeAddressModel.phones[0].countryCode = item.phonePrefix;
            //     _this.alternativePhoneCountry = _.clone(item);
            // }
        };
    
        _this.getPhoneErrorMessage = function(isAlternative) {
            // var phoneCountry = isAlternative ? _this.alternativePhoneCountry : _this.phoneCountry;
            if (! _this.phoneCountry.countryCode ||  _this.phoneCountry.countryCode.length < 2) {
                return inditex.text('Messages_phone');
            }
            var digits = joyr.validation.phoneMaxDigits[ _this.phoneCountry.countryCode];
            if (digits === _this.form.phone.$viewValue.length) {
                return inditex.text('Messages_phone');
            } else {
                return inditex.text('Messages_phone_Digits', digits);
            }
        };

    }

    angular.module('itxApp.common')
    .component('itxAddressPhone',itxAddressPhone);

})();